// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__32Go8","logoContainer":"styles_logoContainer__3xHMs","logo":"styles_logo__1QSmk"};